import Phaser, {
    Display
} from 'phaser'

let sounds;
let buttonArray;
let gameScale;
let world;

export default class Utils extends Phaser.Scene {
    constructor() {
        super('utils');
        buttonArray = new Array;
    }

    create() {

    }

    globalButton(obj) {
        world = this.scene.get('world');
        sounds = this.scene.get('sounds');

        obj.setInteractive({
            useHandCursor: true
        });
        obj.setOrigin(0.5, 0.5);

        obj.on('pointerover', () => this.overOutLanguageButton(obj, 'over'));
        obj.on('pointerout', () => this.overOutLanguageButton(obj, 'out'));
        // @ts-ignore
        obj.on('pointerdown', sounds.playClick);
        obj.on('pointerup', () => {
            world.stopFollow();
        });
        buttonArray.push(obj);

        this.overOutLanguageButton(obj);
    }

    removeButton(obj) {
        obj.removeAllListeners();
        obj.visible = false;
        let index = buttonArray.indexOf(obj);
        if (index > -1) {
            buttonArray.splice(index, 1);
        }
    }

    showButtonLanguage(obj) {
        let isEnglish = this.registry.values.isEnglish;

        let str = obj.getData('str');

        if (isEnglish) {
            obj.setTexture(str + 'English');
        } else {
            obj.setTexture(str + 'Maori');
        }

    }

    handleLanguage() {
        //all the buttons that have gone through the global button function are checked to switch language
        for (let index = 0; index < buttonArray.length; index++) {
            //some of these buttons will be on paused scenes
            if (buttonArray[index].active) {
                this.overOutLanguageButton(buttonArray[index], 'out');
            }
        }
    }

    addImage(thisScene) {
        gameScale = this.registry.values.scaleIt;

        let img;
        let obj;

        for (let index = 1; index < arguments.length; index++) {
            img = arguments[index];
            if (img.id) {
                obj = thisScene.add.image((img.x || 0) * gameScale, (img.y || 0) * gameScale, img.id);
                obj.setFlipX(img.flip || false);
                obj.setScale(img.scale || img.scaleX || 1, img.scale || img.scaleY || 1);
            } else {
                let scaledpoly = new Array;
                //find the scaled coordinates
                for (let index = 0; index < img.hit.length; index++) {
                    scaledpoly.push([img.hit[index][0] * gameScale, img.hit[index][1] * gameScale]);
                }
                //adjust polygon based on scaled coordinates
                obj = thisScene.add.polygon(img.x * gameScale, img.y * gameScale, scaledpoly, 0xffffff);
                obj.alpha = 0.001;
            }

            obj.setOrigin(img.originX || 0, img.originY || 0);
            obj.rotation = img.rotation || 0;

            obj.setData({
                english: img.english,
                maori: img.maori,
                hit: img.hit,
                location: img.location,
                str: img.str,
                swapImage: img.swapImage
            });

            return (obj);
        }
    }
    randomNumber(val = 10) {
        //could an array have been passed?
        let randomNumber;
        if (val.length > 1) {
            randomNumber = Phaser.Math.RND.pick(val);
        } else {
            randomNumber = Phaser.Math.RND.integerInRange(0, val);

        }

        return randomNumber;
    }


    overOutLanguageButton(obj, type = 'out') {

        let isEnglish = this.registry.values.isEnglish;
        let show = 'English';
        let str = obj.getData('str');

        if ((type == 'over' && isEnglish == true) || (type == 'out' && isEnglish == false)) {
            show = 'Maori'
        }

        if (type == 'over') {
            obj.scale = 1.03;
            obj.setTexture(str + show);
        } else {
            obj.scale = 1;
            obj.setTexture(str + show);
        }
    }

    highlightText(str, keyword = this.registry.values.keyword[1]) {
        //replace all instances of keyword /g and all capitlisations
        //let reg = / + keyword + /gi;
        let regex = new RegExp(keyword, "g");
        let txt = str.replace(regex, '<span class="keyword">' + keyword + '</span>')
        return (txt);
    }


}